export const calculateVAA_ATN = (fiscalValue: number) => {
    if (!!fiscalValue) return Math.round((fiscalValue * 0.04 * 6) / 7 / 12).toFixed(2)
}
